// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* Footer */\n.store-footer[data-v-5fd336d9] {\n  color: #666;\n  background: #e4e4e4;\n  border-top: 1px solid #eee;\n  font-size: 14px;\n  padding: 10px 16px 16px;\n}\n.store-footer div[data-v-5fd336d9] {\n  text-align: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
